import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App, { browserHistory } from "./App";
import * as Sentry from "@sentry/react";
import { VERSION } from "./Version";
import { dsn } from './Sentry';
import { createRoot } from 'react-dom/client';
import { installFatalErrorTrapInDev } from "./Util";
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { get_deployment } from './API';

installFatalErrorTrapInDev();


const host = window.location.host;
let environment = 'production';
let datadogEnvironment = 'prod';
if (host?.includes('local.dev') || host?.includes('goat-mamba') || host?.includes('.local')) {
  environment = 'development';
  datadogEnvironment = 'dev';
}

Sentry.init({
  dsn,
  debug: false,
  environment,
  ignoreErrors: [
    'Non-Error promise rejection captured',
    /Shopify root is null/, // Facebook/Instagram IAB injected script error
  ],
  integrations: [Sentry.reactRouterV5BrowserTracingIntegration({
    history: browserHistory
  })],
  tracesSampleRate: 1.0,
  release: "aidkit@" + VERSION
});

// This can be used in local development to test Datadog RUM, but should be kept prod-only by default.
if (datadogEnvironment === 'prod') {
  datadogRum.init({
    applicationId: '2f39dc92-6fd9-4124-8427-3fcb96663abe',
    clientToken: 'pub8b683e8a4dd231723226067d890f5a59',
    site: 'datadoghq.com',
    service: 'aidkit-frontend',
    env: datadogEnvironment,
    version: VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    enablePrivacyForActionName: true,
    trackLongTasks: true,
    plugins: [reactPlugin({ router: false })],
  });

  datadogRum.setViewName(`${browserHistory.location.pathname}${browserHistory.location.search}${browserHistory.location.hash}`);
  browserHistory.listen((location) => {
    datadogRum.setViewName(`${location.pathname}${location.search}${location.hash}`);
  });
}
const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(<App />);
